export const downloadFile = (data: string | Blob | BlobPart[], fileName: string) => {
	let href: string;
	if (typeof data === 'string' && data.startsWith('data:')) {
		href = data;
	} else {
		const blob = new Blob(Array.isArray(data) ? data : [data]);
		href = window.URL.createObjectURL(blob);
	}
	const link = document.createElement('a');
	link.href = href;
	link.setAttribute('download', fileName);
	document.body.appendChild(link);
	link.click();
	link.remove();
}
